import React, { FunctionComponent } from 'react';

import { useDispatch } from 'react-redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import AppState from '@webapp/store/state';

import styled from 'styled-components';

import MetricsWidget from '../metrics-widget';
import AnalyticsIndicator from '../metrics-widget/analytics-indicator';

import { GetArtistAnalytics } from '@webapp/store/artist-analytics/action-creators';
import { MonthAnalytics } from '@webapp/store/artist-analytics/state';
import { AnalyticsQueryTypes } from '@services/analytics/types/analytics-query-enum';

interface AnalyticsWidgetProps {
  className?: string;
  artistId?: string;
  isExampleData: boolean;
  lastMonthAnalytics: MonthAnalytics;
  withoutData: boolean;
}

const mapStateToProps = (state: AppState) => ({
  isExampleData: state.artistAnalytics.isExample,
  lastMonthAnalytics: state.artistAnalytics.lastMonthAnalytics,
  withoutData: !state.artistAnalytics.lastMonthAnalytics.timeseries.some(
    (val) => val.value !== 0
  ),
});

const AnalyticsWidget: FunctionComponent<AnalyticsWidgetProps> = ({
  className,
  artistId,
  isExampleData,
  lastMonthAnalytics,
}) => {
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(push(`/analytics`));
  };

  React.useEffect(() => {
    if (artistId) {
      dispatch(new GetArtistAnalytics(AnalyticsQueryTypes.ENGAGEMENT));
      dispatch(new GetArtistAnalytics(AnalyticsQueryTypes.COUNTS));
    }
  }, [artistId, dispatch]);

  return (
    <MetricsWidget
      className={className || ''}
      title="DASHBOARD.NEW_DASHBOARD.METRICS.ANALYTICS.TITLE"
      subtitle="DASHBOARD.NEW_DASHBOARD.METRICS.ANALYTICS.SUBTITLE"
      onClick={handleClick}
    >
      <Container>
        <ReferenceWrapper>
          <AnalyticsIndicator
            refText="DASHBOARD.NEW_DASHBOARD.METRICS.ANALYTICS.STREAMS"
            textTop={true}
            label={
              lastMonthAnalytics && !isExampleData
                ? lastMonthAnalytics.change
                : 0
            }
          />
          <AnalyticsIndicator
            refText="DASHBOARD.NEW_DASHBOARD.METRICS.ANALYTICS.FANS"
            textTop={true}
            label={0}
          />
        </ReferenceWrapper>
      </Container>
    </MetricsWidget>
  );
};

export default connect(mapStateToProps)(AnalyticsWidget);

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
`;

const ReferenceWrapper = styled.div`
  display: flex;
  margin: 20px auto auto 0px;
  flex-direction: row;
  justify-content: flex-end;
  gap: 40px;
  grid-column: span 3;
`;
